/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_School_Switcher_Trial_BadgeInputs */

const nl_nav_school_switcher_trial_badge = /** @type {(inputs: Nav_School_Switcher_Trial_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proef`)
};

/**

* @param {Nav_School_Switcher_Trial_BadgeInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_school_switcher_trial_badge = /** @type {((inputs?: Nav_School_Switcher_Trial_BadgeInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_School_Switcher_Trial_BadgeInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_school_switcher_trial_badge(inputs)
});
export { nav_school_switcher_trial_badge as "nav.school_switcher.trial_badge" }